export const logo = require("../assets/appLogo.png");
export const apple= require("../assets/android.png");
export const google = require("../assets/apple.png");
export const linkdin = require("../assets/linkdin.png");
export const facebook= require("../assets/facebook.png");
export const twitter= require("../assets/twitter.png");
export const qrcode = require("../assets/qrcode.png");
export const contactUs = require("../assets/contactUs.png");
export const forwardIcon = require("../assets/forwardArrow.png");
export const videoPauseimg = require("../assets/videoPauseImg.png");
export const downArrow = require("../assets/downArrow.png");
export const landingpage = require("../assets/landingpage.jpeg");
export const leftArrow = require("../assets/leftArrow.png");
export const marketingImage = require("../assets/marketingImage.png")
export const forwardArrow = require("../assets/forwardArrow.png")
export const rightArrow = require("../assets/rightArrow.png")
export const carousalImage = require("../assets/carousal.png")
export const heroImg = require("../assets/hero_img.jpeg")
export const connectImg = require("../assets/connect_side_img.png")
export const pitchImg = require("../assets/inverted_bw_image.png")
export const videoPlayimg = require("../assets/videoPlayImg.png");
export const Applogo = require("../assets/logo.png");
export const email = require("../assets/mail.png");
export const phone = require("../assets/phone.png");

 







